export default __webpack_public_path__ + "static/media/BackupRetention.31966faa.png";